import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-jumping-dots',
    templateUrl: './jumping-dots.component.html',
    styleUrls: ['./jumping-dots.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class JumpingDotsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
